import type { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { ENV_CONFIG } from '@core/config/environment.token';
import { apiPath } from './api-request-policy';

export const credentialsInterceptor: HttpInterceptorFn = (req, next) => {
  const env = inject(ENV_CONFIG);
  const document = inject(DOCUMENT);
  return next(
    apiPath(req.url, env.api.baseUrl, document.baseURI) === null
      ? req
      : req.clone({ withCredentials: true })
  );
};
